import { Skeleton } from '../ui/skeleton/skeleton';

interface SkeletonCardProps {
  className?: string;
}

export function SkeletonText({ className }: SkeletonCardProps) {
  return <Skeleton className={`w-full h-[10px] bg-skeleton rounded-[8px] ${className} `} />;
}
